
define('ldsh!modules/editor/templates/property_boxes/page_gtm', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="ed-modal-content ed-opt-content ed-tab-content active">\n  <div class="col one-half">\n    <div class="ed-form-group align-left">\n       <label for="gtmId" data-i18n="editor.page.gtmTitle"></label>\n       <input id="gtmId" type="text" class="ed-form-control js-gtmId" data-property="gtmId" style="width:215px;" />\n    </div>\n  </div>\n</div>\n<div class="alert-warning f14">\n  <span data-i18n="editor.page.gtmHelp"></span>\n</div>\n';

}
return __p
};});

